















































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'

import { Widget } from '../base/'
import { DateTimeService } from 'base/services/DateTimeService'

import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    NoWidgetAccess
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    }
  },
  data() {
    return {
      timer: null,
      timeFactor: 1000,
      elapsedTime: 0,
      timeLeft: 0,
    }
  },
  computed: {
    ...mapGetters(['getCurrentAlarmId']),
    currentAlarm(): any | null {
      return this.$store.state.alarm.items[this.getCurrentAlarmId] || null
    },
    startTime(): any {
      return this.currentAlarm?.date
    },
    duration(): number {
      return this.widget?.customSettings.settings?.duration.value
    },
    durationMs(): number {
      return this.duration * 60
    },
    fontSize(): number {
      return this.widget?.customSettings.settings?.fontSize.value
    },
    fontSizeLabel(): number {
      return this.widget?.customSettings.settings?.fontSizeLabel.value
    },
    showTimeFormatLabel(): boolean {
      return this.widget?.customSettings.settings?.showTimeFormatLabel.checked
    },
    timeFormat(): any {
      return this.widget?.customSettings.settings?.timeFormat.value
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
          this.elapsedTime = DateTimeService.unixTimestamp() - this.startTime
        }, this.timeFactor)
    },
    stopTimer() {
      if(!this.timer) return

      clearInterval(this.timer)
        this.timer = null
    },
  },
  watch: {
    elapsedTime(val) {
      if (!this.currentAlarm) return

      this.timeLeft = (this.startTime + (this.duration * 60 * 1000)) - (val * 1000)
      if (this.timeLeft <= this.startTime) this.stopTimer()
    }
  },
  mounted() {
    this.startTimer()
  },
  destroyed() {
    this.stopTimer()
  }
})
